import React from 'react'
import {BackTop, Drawer, Menu} from 'antd';
import Logo from '../assets/img/cd-nav-logo.svg'
import LogoVistaar from '../assets/img/v_logo_full_black.svg'
import {Link} from 'react-router-dom'
import './index.css'
import {MenuOutlined} from '@ant-design/icons';
import {partnerData} from "../footer/footerData";

const {SubMenu} = Menu;

const BuildingIcon = () => (
    <svg width="1em" height="1em" fill="#00c851" viewBox="0 0 1792 1792">
        <path
            d="M1472 0q26 0 45 19t19 45v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280zm-832 288v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm0 256v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zm-128 320v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm512 1280v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-512v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 1024v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zm0-256v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23z"/>
    </svg>
);

class NavMenu extends React.Component {
    state = {
        openKeys: [],
        loginmodal: false,
        registermodal: false,
    }

    loginmodal(loginmodal) {
        this.setState({loginmodal});
    }

    registermodal(registermodal) {
        this.setState({registermodal});
    }

    onOpenChange = openKeys => {
        if (openKeys.length) {
            if (!openKeys[openKeys.length - 1].startsWith(openKeys[0])) {
                openKeys = [openKeys[openKeys.length - 1],]
            }
        } else {
            openKeys = []
        }
        this.setState({openKeys});
    };

    render() {
        return <div className="menu">
            <Menu
                mode={this.props.mode}
                openKeys={this.state.openKeys}
                onOpenChange={this.onOpenChange}
            >
                <SubMenu title="Language Classs">
                    <Menu.Item key="French">
                        <Link to="/language_class/french"
                              className="text-decoration-none my-cd-menu-color">French</Link>
                    </Menu.Item>
                    <Menu.Item key="ILETTS">
                        <Link to="/language_class/ielts" className="text-decoration-none my-cd-menu-color">IELTS</Link>
                    </Menu.Item>
                    <Menu.Item key="English">
                        <Link to="/language_class/english"
                              className="text-decoration-none my-cd-menu-color">English</Link>
                    </Menu.Item>
                </SubMenu>
                <Menu.Item key="Exams">
                    <Link to="/exams" className="text-decoration-none my-cd-menu-color">Exams</Link>
                </Menu.Item>
                <SubMenu title="Maths/Science">
                    <Menu.Item key="Interactive Classes">
                        <Link to="/interactive_class" className="text-decoration-none my-cd-menu-color">Interactive
                            Classes</Link>
                    </Menu.Item>
                    <Menu.Item key="Demo Classes">
                        <Link to="/demo_class" className="text-decoration-none my-cd-menu-color">Demo Classes</Link>
                    </Menu.Item>
                    {/*<Menu.Item key="LIVE Classes">*/}
                    {/*    <Link to="/live_class" className="text-decoration-none my-cd-menu-color">LIVE Classes</Link>*/}
                    {/*</Menu.Item>*/}
                    <SubMenu title="Syllabus">
                        <Menu.Item key="Class_5">
                            <Link to="/class5_syllabus" className="text-decoration-none my-cd-menu-color">Class 5</Link>
                        </Menu.Item>
                        <Menu.Item key="Class_6">
                            <Link to="/class6_syllabus" className="text-decoration-none my-cd-menu-color">Class 6</Link>
                        </Menu.Item>
                        <Menu.Item key="Class_7">
                            <Link to="/class7_syllabus" className="text-decoration-none my-cd-menu-color">Class 7</Link>
                        </Menu.Item>
                        <Menu.Item key="Class_8">
                            <Link to="/class8_syllabus" className="text-decoration-none my-cd-menu-color">Class 8</Link>
                        </Menu.Item>
                        <Menu.Item key="Class_9">
                            <Link to="/class9_syllabus" className="text-decoration-none my-cd-menu-color">Class 9</Link>
                        </Menu.Item>
                        <Menu.Item key="Class_10">
                            <Link to="/class10_syllabus" className="text-decoration-none my-cd-menu-color">Class
                                10</Link>
                        </Menu.Item>
                    </SubMenu>
                </SubMenu>
                <SubMenu title="Career Guidance">
                    <Menu.Item key="After 10th">
                        <Link to="/after_10" className="text-decoration-none my-cd-menu-color"><i
                            className="fas fa-school mr-2 text-primary"/>After 10<sup>th</sup></Link>
                    </Menu.Item>
                    {/*<Menu.Item key="After 12th">*/}
                    {/*    <Link to="" className="text-decoration-none my-cd-menu-color"><i className="fas fa-university mr-2 text-info"/>After 12<sup>th</sup></Link>*/}
                    {/*</Menu.Item>*/}
                    <Menu.Item key="Study Abroad">
                        <Link to="/study_abroad" className="text-decoration-none my-cd-menu-color"><i
                            className="fas fa-globe-americas mr-2 cd-blue-text"/>Study Abroad</Link>
                    </Menu.Item>
                    <Menu.Item key="Portfolio Management">
                        <Link to="/portfolio_management" className="text-decoration-none my-cd-menu-color"><i
                            className="fas fa-portrait mr-2 cd-green-text"/>Portfolio Management</Link>
                    </Menu.Item>
                </SubMenu>
                <Menu.Item key="Buy A Course" className="my-cd-menu-color">
                    <Link to="/buy_course" className="text-decoration-none my-cd-menu-color">Buy A Course</Link>
                </Menu.Item>
                <Menu.Item key="Study Center">
                    <Link to="/study_center" className="text-decoration-none my-cd-menu-color">Study Center</Link>
                </Menu.Item>
                <SubMenu title="More">
                    {/*<Menu.Item key="Blog">*/}
                    {/*    <Link to="/blogs" className="text-decoration-none my-cd-menu-color"><i className="fab fa-blogger-b mr-2 text-primary"></i>Blog</Link>*/}
                    {/*</Menu.Item>*/}
                    <Menu.Item key="We Are Hiring">
                        <Link to="/hr_careerdose" className="text-decoration-none my-cd-menu-color"><i
                            className="fas fa-vote-yea mr-2 text-info"/>We are Hiring</Link>
                    </Menu.Item>
                    <Menu.Item key="Contact Us">
                        <Link to="/contact_us" className="text-decoration-none my-cd-menu-color"><i
                            className="fas fa-phone text-danger mr-2"/>Contact Us</Link>
                    </Menu.Item>
                    <SubMenu title={<><i className="fas fa-building text-success mr-2"/>Our Branches</>}>
                        {
                            partnerData.map((item, index) => {
                                return <Menu.Item key={item.class}>
                                    <Link to={item.link} className="text-decoration-none my-cd-menu-color"><i
                                    />{item.class}</Link>
                                </Menu.Item>
                            })
                        }
                    </SubMenu>

                </SubMenu>
                <Menu.Item key="vistaar">
                    <a href={"https://vistaar.careerdose.com"} target={"_blank"}><img loading="lazy" src={LogoVistaar} alt="Career Dose French Learning" height={20}/></a>
                </Menu.Item>
                {/*<SubMenu title="Account">*/}
                {/*    <Menu.Item key="1" onClick={() => this.loginmodal(true)}>*/}
                {/*        <i className="fas fa-sign-in-alt mr-2 cd-green-text"/>Login*/}
                {/*    </Menu.Item>*/}
                {/*    <Modal*/}
                {/*        title={null}*/}
                {/*        centered*/}
                {/*        visible={this.state.loginmodal}*/}
                {/*        onOk={() => this.loginmodal(false)}*/}
                {/*        onCancel={() => this.loginmodal(false)}*/}
                {/*        footer={null}*/}
                {/*        zIndex={9999}*/}
                {/*        mask*/}
                {/*        maskClosable*/}
                {/*    >*/}
                {/*        <div className="row account">*/}
                {/*            <div className="col-xl-6 col-lg-6 col-md-6 p-5">*/}
                {/*                <img src={Loginimg} className="img-fluid"/>*/}
                {/*            </div>*/}
                {/*            <div className="col-xl-6 col-lg-6 col-md-6">*/}
                {/*                <div className="card border-0 h-100">*/}
                {/*                    <div className="card-body">*/}
                {/*                        <h1 className="font-weight-bold mb-4">Login</h1>*/}
                {/*                        <Form*/}
                {/*                            onFinish={(val) => console.log(val)}*/}
                {/*                            name="login"*/}
                {/*                            className="border-0 cd-form cd-form-primary mb-2"*/}
                {/*                            initialValues={{*/}
                {/*                                "login_as": ""*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            <label className="font-weight-bold">Phone Number</label>*/}
                {/*                            <Form.Item*/}
                {/*                                name="login_tel"*/}
                {/*                                hasFeedback*/}
                {/*                                rules={[{required: true, message: 'Please enter your phone.'}]}*/}
                {/*                            >*/}
                {/*                                <input type="tel" className="text-uppercase"/>*/}
                {/*                            </Form.Item>*/}
                {/*                            <label className="font-weight-bold">Password</label>*/}
                {/*                            <Form.Item*/}
                {/*                                name="login_password"*/}
                {/*                                rules={[{required: true, message: 'Please enter your password.'}]}*/}
                {/*                            >*/}
                {/*                                <input type="password" className="text-uppercase"/>*/}
                {/*                            </Form.Item>*/}
                {/*                            <div>*/}
                {/*                                <p className="m-0">Forgot Password</p>*/}
                {/*                            </div>*/}
                {/*                            <Form.Item name="remember" valuePropName="checked" className="m-0">*/}
                {/*                                <Checkbox>Remember me</Checkbox>*/}
                {/*                            </Form.Item>*/}
                {/*                            <button type="submit" className="py-2 px-4 btn cd-pill mdb-blue-gradient border-0 text-white text-uppercase letter-space font-weight-bold mt-4">Login<i*/}
                {/*                                className="fas fa-arrow-right ml-2"></i></button>*/}
                {/*                        </Form>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </Modal>*/}
                {/*    <Menu.Item key="2">*/}
                {/*        <Link to="/my_profile" className="text-decoration-none text-dark">*/}
                {/*            <i className="fas fa-user-circle mr-2 text-primary"></i>My Profile*/}
                {/*        </Link>*/}
                {/*    </Menu.Item>*/}
                {/*    <Menu.Item key="3">*/}
                {/*        <i className="fas fa-sign-out-alt mr-2 cd-red-text"></i>Logout*/}
                {/*    </Menu.Item>*/}
                {/*    <Menu.Item key="4" onClick={() => this.registermodal(true)}>*/}
                {/*        <i className="fas fa-user-plus mr-2 text-info"></i>Register*/}
                {/*    </Menu.Item>*/}
                {/*    <Modal*/}
                {/*        title={null}*/}
                {/*        centered*/}
                {/*        visible={this.state.registermodal}*/}
                {/*        onOk={() => this.registermodal(false)}*/}
                {/*        onCancel={() => this.registermodal(false)}*/}
                {/*        zIndex={9999}*/}
                {/*        footer={null}*/}
                {/*        mask*/}
                {/*        maskClosable*/}
                {/*    >*/}
                {/*        <div className="row account">*/}
                {/*            <div className="col-xl-4 col-lg-4 col-md-4 p-5">*/}
                {/*                <img src={Registerimg} className="h-100"/>*/}
                {/*            </div>*/}
                {/*            <div className="col-xl-8 col-lg-8 col-md-8 ">*/}
                {/*                <div className="card border-0 h-100">*/}
                {/*                    <div className="card-body">*/}
                {/*                        <h1 className="font-weight-bold mb-4">Register</h1>*/}
                {/*                        <Form*/}
                {/*                            onFinish={(val) => console.log(val)}*/}
                {/*                            name="login"*/}
                {/*                            className="border-0 cd-form cd-form-primary"*/}
                {/*                            initialValues={{*/}
                {/*                                "register_as": ""*/}
                {/*                            }}*/}
                {/*                        >*/}
                {/*                            <label className="font-weight-bold">Phone Number</label>*/}
                {/*                            <Form.Item*/}
                {/*                                name="login_tel"*/}
                {/*                                hasFeedback*/}
                {/*                                rules={[{required: true, message: 'Please enter your phone.'}]}*/}
                {/*                            >*/}
                {/*                                <input type="tel" className="text-uppercase"/>*/}
                {/*                            </Form.Item>*/}
                {/*                            <label className="font-weight-bold">Password</label>*/}
                {/*                            <Form.Item*/}
                {/*                                name="login_password"*/}
                {/*                                rules={[{required: true, message: 'Please enter your password.'}]}*/}
                {/*                            >*/}
                {/*                                <input type="password" className="text-uppercase"/>*/}
                {/*                            </Form.Item>*/}
                {/*                            <button type="submit" className="py-2 px-4 btn cd-pill mdb-blue-gradient border-0 text-white text-uppercase letter-space font-weight-bold mt-2">Login<i*/}
                {/*                                className="fas fa-arrow-right ml-2"/></button>*/}
                {/*                        </Form>*/}
                {/*                    </div>*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </Modal>*/}
                {/*</SubMenu>*/}
            </Menu>
        </div>

    }
}

class Navbar extends React.Component {
    state = {
        visible: false,
        menu: [],
    }
    showDrawer = () => {
        this.setState({
            visible: true
        });
    };
    onClose = () => {
        this.setState({
            visible: false
        });
    };

    updateDimensions() {
        const menu = [];
        if (window.innerWidth > 1024) {
            menu.push(<NavMenu mode="horizontal"/>);
        } else {
            menu.push(<>
                <div className="cd-menu-toggle" onClick={this.showDrawer}>
                    <MenuOutlined/>
                </div>
            </>);
        }
        this.setState({
            menu: [...menu],
        });
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    render() {
        const {menu} = this.state;
        return (
            <header className="d-flex justify-content-between">
                <div className="logo">
                    <Link to="/">
                        <img loading="lazy" src={Logo} alt="Career Dose"/>
                    </Link>
                </div>
                {menu}
                <Drawer
                    placement="right"
                    closable={true}
                    onClose={this.onClose}
                    visible={this.state.visible}
                >
                    <NavMenu mode="inline"/>
                </Drawer>
                <BackTop/>
            </header>
        )
    }
}

export default Navbar;
